import React, { useState } from "react";
import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import MainNav from "./MainNav";

const SIDEBAR_COLLAPSED = 68;
const SIDEBAR_EXPANDED = 260;

const AppLayout: React.FC = () => {
  const [hovered, setHovered] = useState(false);
  const location = useLocation();

  const currentPath = location.pathname;
  const isPosPage = currentPath === "/pos";

  if (isPosPage) {
    return (
      <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
            backgroundColor: "#f9fafb",
          }}>
          <Outlet />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      {/* Sidebar — collapsed by default, expands on hover */}
      <Box
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        sx={{
          width: hovered ? SIDEBAR_EXPANDED : SIDEBAR_COLLAPSED,
          flexShrink: 0,
          height: "100vh",
          background: "linear-gradient(180deg, #7f1d1d 0%, #991b1b 100%)",
          transition: "width 0.25s ease",
          overflow: "hidden",
          zIndex: (theme) => theme.zIndex.drawer,
          position: "relative",
        }}>
        <MainNav collapsed={!hovered} />
      </Box>

      {/* Main content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: "100vh",
          overflow: "auto",
          backgroundColor: "#f9fafb",
        }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default AppLayout;
